import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import { useFieldArray } from 'react-hook-form'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import styles from './HFInputs.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import HFDropdown from './HFDropdown'
import HFTextInput from './HFTextInput'
import { AppointmentStatus } from 'utils/enums'

export const APPOINTMENT_APPROVED_STATES = [
	AppointmentStatus.Scheduled,
	AppointmentStatus.Executed,
	AppointmentStatus.Approved,
]

const HFAppointmentPresetProtocol = (props) => {
	const { name, data } = props

	const { i18n } = useGlobal()

	const { medicalSpecialties } = data

	const { fields, append, remove } = useFieldArray({
		name,
		keyName: 'key',
	})

	return (
		<>
			<HStack gap='small' justify='space-between' columns={['75px', 4]}>
				<small className={styles['quantity-container']}>
					<strong>{i18n`Qtd.`}</strong>
				</small>
				<small>
					<strong>{i18n`Expertise`}</strong>
				</small>
			</HStack>
			{fields.map(({ key }, index) => {
				return (
					<HStack
						key={key}
						wrap='nowrap'
						gap='xsmall'
						className={styles['process-protocol-field']}
					>
						<HStack
							gap='small'
							justify='space-between'
							columns={['75px', 4]}
						>
							<div>
								<HFTextInput
									name={`${name}.${index}.quantity`}
									type='number'
									placeholder=''
									displaySuffixIcon={false}
									inputMode={'numeric'}
									multiline={false}
									noResize
									ignoreCustomValidity={false}
								/>
							</div>
							<div>
								<HFDropdown
									name={`${name}.${index}.specialtyId`}
									options={medicalSpecialties || []}
									searchable={true}
									noData={i18n`No results`}
								/>
							</div>
						</HStack>
						<Icon
							className={styles['remove-button']}
							onClick={(e) => {
								e.preventDefault()
								remove(index)
							}}
							name='minus'
							height='12px'
							width='12px'
						/>
					</HStack>
				)
			})}
			<ActionButton
				className={styles['add-appointment-protocol']}
				secondary
				onClick={(e) => {
					e.preventDefault()
					append({
						quantity: 1,
						specialtyId: '',
					})
				}}
			>
				<Icon name='plus' height='14px' width='14px' />
				<small>{i18n`Add`}</small>
			</ActionButton>
		</>
	)
}

export default HFAppointmentPresetProtocol
